import { jsx as _jsx } from "react/jsx-runtime";
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { RouterProvider, createBrowserRouter } from 'react-router';
const Component = ({ routes }) => {
    return _jsx(RouterProvider, { router: createBrowserRouter(routes) });
};
export const AuthenticatedBrowserRouterProvider = withAuthenticationRequired(Component);
